export class LeadsReportModel {
	startDate: Date;
	endDate: Date;
	statusIds: number[] = [];
	initTypeIds: number[] = [];
}
